/* unplugin-vue-components disabled */import { render } from "./select-sh-companies.vue?vue&type=template&id=37100cd8&scoped=true"
import script from "./select-sh-companies.vue?vue&type=script&lang=js"
export * from "./select-sh-companies.vue?vue&type=script&lang=js"

import "./select-sh-companies.vue?vue&type=style&index=0&id=37100cd8&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37100cd8"],['__file',"src/controls/select-sh-companies.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37100cd8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37100cd8', __exports__)) {
    api.reload('37100cd8', __exports__)
  }
  
  module.hot.accept("./select-sh-companies.vue?vue&type=template&id=37100cd8&scoped=true", () => {
    api.rerender('37100cd8', render)
  })

}


export default __exports__